var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-item',{attrs:{"show-actions":false,"title":_vm.title,"model":_vm.$productIngredientGroupIngredient,"show-delete":false},scopedSlots:_vm._u([{key:"default",fn:function({ object, rules }){return [_c('div',{staticClass:"text-h5"},[_vm._v(_vm._s(object.name))]),_c('ProductIngredientGroupIngredientTabs'),_c('router-view')]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }